import React from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Modal from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const BlockModalFooter = ({
  onCancel,
  onOk,
  screenerID,
}: {
  onCancel: () => void;
  onOk: (screenerID: number | string) => void;
  screenerID: string | number;
}) => (
  <Flex>
    <Button
      block
      height="40px"
      type="borderless"
      radius="unset"
      onClick={() => onCancel()}
      style={{ borderTop: `1px solid ${color.gainsboro}` }}
    >
      Cancel
    </Button>

    <Button
      type="primary"
      radius="unset"
      block
      height="40px"
      onClick={() => onOk(screenerID)}
    >
      Confirm
    </Button>
  </Flex>
);

const ModalContainer = styled.div`
  padding: 0 16px;
`;

const DeleteModal = ({
  isVisible,
  title,
  screenerName,
  screenerID,
  onCancel,
  onOk,
}: {
  isVisible: boolean;
  title: string;
  screenerName: string;
  screenerID: string | number;
  onCancel: () => void;
  onOk: (screenerID: number | string) => void;
}) => {
  const ModalContent = (
    // @ts-expect-error
    <Text pb="15px">
      Are you sure want to remove &quot;{screenerName}&quot; ?
    </Text>
  );

  const ModalFooter = (
    <BlockModalFooter onOk={onOk} onCancel={onCancel} screenerID={screenerID} />
  );

  return (
    <Modal
      destroyOnClose
      visible={isVisible}
      title={(
        <Text
          // @ts-expect-error
          p="18px"
          align="center"
          family="bold"
          size="18px"
        >
          {title}
        </Text>
      )}
      footer={ModalFooter}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      onCancel={onCancel}
      centered
    >
      <ModalContainer>{ModalContent}</ModalContainer>
    </Modal>
  );
};

export default DeleteModal;
